var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadVideoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8637 2.36321C12.2152 2.01174 12.785 2.01174 13.1365 2.36321L19.1365 8.36321C19.488 8.71468 19.488 9.28453 19.1365 9.63601C18.785 9.98748 18.2152 9.98748 17.8637 9.63601L13.4001 5.1724V15.9996C13.4001 16.4967 12.9972 16.8996 12.5001 16.8996C12.003 16.8996 11.6001 16.4967 11.6001 15.9996V5.1724L7.13649 9.63601C6.78502 9.98748 6.21517 9.98748 5.8637 9.63601C5.51223 9.28453 5.51223 8.71468 5.8637 8.36321L11.8637 2.36321ZM4.6001 19.9996C4.6001 19.5026 5.00304 19.0996 5.5001 19.0996H19.5001C19.9972 19.0996 20.4001 19.5026 20.4001 19.9996C20.4001 20.4967 19.9972 20.8996 19.5001 20.8996H5.5001C5.00304 20.8996 4.6001 20.4967 4.6001 19.9996Z",
    fill: "#AC92ED"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideoIcon);
export default __webpack_public_path__ + "static/media/upload_video_icon.6c1127b47d2f76c6c459ef16e1195335.svg";
export { ForwardRef as ReactComponent };